import { Icon, Menu } from 'antd';
import _ from 'lodash';
import { UISetting } from 'o2o_layout/lib/common/model';
import React, { useEffect, useState } from 'react';
import { Location } from 'history';
import { IState } from '../../../../redux/reducer';
import { useSelector, useDispatch } from '../../../../redux/store';
import { checkPermission } from '../../../../common/helper';
import { IActionUI, OWNER_PERMISSION } from '../../../../redux/reducer/uiReducer';
import { canAccess } from 'o2o_layout';
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import { IconShieldSuperAdmin } from '@shares/DMPIcon';
import { InternalPermissionDAL } from '../../../../modules/users/internal_permission/DAL/InternalPermissionDAL';

interface IProps {
  selectedLeftNav: string;
  selectedSubMenu: string;
  commonActionFromDALV2: any;
  commonActionFromDAL: any;
  location: Location;
  uiSetting: UISetting;
  collapsed: boolean;
  open: any;
}

export const MainMenu = (props: IProps) => {
  const dispatch = useDispatch();
  const [selectedLeftNav] = useState<string[]>([props.selectedLeftNav]);
  const [selectedSubMenu, setSelectedSubMenu] = useState<string[]>([props.selectedSubMenu]);

  useEffect(() => {
    const userRoles = user ? (user.orgCtx ? user.orgCtx.roles : []) : [];
    if (canAccess(['SUPER_ADMIN'], userRoles)) {
      loadOwnerHasPermission();
    }
  }, []);

  const loadOwnerHasPermission = async () => {
    const result = props.commonActionFromDALV2(InternalPermissionDAL.hasOwnerPermission);
    try {
      const response = await result;
      dispatch({
        type: OWNER_PERMISSION,
        ownerPermission: response.success,
      } as IActionUI);
    } catch (error) {
      dispatch({
        type: OWNER_PERMISSION,
        ownerPermission: false,
      } as IActionUI);
    }
  };

  const { permission } = useSelector((state: IState) => state.authen);

  const user = useSelector((state: IState) => state.user);
  const userRoles = user ? (user.orgCtx ? user.orgCtx.roles : []) : [];

  const qString = props.location.search;
  const parseQuery = queryString.parse(qString);
  let lang = parseQuery.lang;

  return (
    <Menu
      theme='light'
      key={props.collapsed ? 'collapsed' : 'expanded'}
      defaultSelectedKeys={selectedLeftNav ? selectedLeftNav : []}
      defaultOpenKeys={selectedSubMenu ? selectedSubMenu : []}
      style={{
        borderColor: 'transparent',
        marginTop: 15,
        marginBottom: 20,
        background: 'transparent',
      }}
      mode='inline'
      // onClick={(e: any) => {
      //     dispatch({
      //       type: UPDATE_ERROR,
      //       errorStatus: 0,
      //     } as IActionUI);
      //   }}
      onOpenChange={(e: string[]) => {
        if (e.length) {
          setSelectedSubMenu(e);
        } else {
          setSelectedSubMenu([]);
        }
      }}
    >
      <Menu.Item key='my-info'>
        <Link
          to={{
            pathname: '/my-account-info',
            search: queryString.stringify({ lang: lang }),
          }}
        >
          <Icon
            component={() => (
              <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M2.46644 16.3333H13.5335C14.8691 16.3333 15.5 15.9188 15.5 15.0228C15.5 12.7695 12.6476 9.53332 7.99663 9.53332C3.35234 9.53332 0.5 12.7695 0.5 15.0228C0.5 15.9188 1.13087 16.3333 2.46644 16.3333ZM2.13758 15.2167C1.80873 15.2167 1.68792 15.1298 1.68792 14.8891C1.68792 13.3311 3.96308 10.6566 7.99663 10.6566C12.0369 10.6566 14.3121 13.3311 14.3121 14.8891C14.3121 15.1298 14.1913 15.2167 13.8624 15.2167H2.13758ZM8.01003 8.39661C10.0436 8.39661 11.6812 6.61134 11.6812 4.39816C11.6812 2.22508 10.0436 0.5 8.01003 0.5C5.98322 0.5 4.33221 2.25183 4.33221 4.41153C4.33221 6.61803 5.9765 8.39661 8.01003 8.39661ZM8.01003 7.27998C6.64764 7.27998 5.52013 6.02295 5.52013 4.41153C5.52013 2.84691 6.64093 1.61662 8.01003 1.61662C9.37917 1.61662 10.4933 2.82686 10.4933 4.39816C10.4933 6.00958 9.3725 7.27998 8.01003 7.27998Z'
                  fill='currentColor'
                />
              </svg>
            )}
          />
          <span>Profile</span>
        </Link>
      </Menu.Item>

      {canAccess(['ADMIN', 'SUPER_ADMIN'], userRoles) ? (
        <Menu.SubMenu
          key='console'
          title={
            <span>
              <Icon
                component={() => (
                  <svg width='18' height='20' viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M10.9556 10.6278L11.2922 10.5037C10.2352 9.98287 8.95914 9.6549 7.50143 9.6549C2.98288 9.6549 0.207764 12.8153 0.207764 15.0158C0.207764 15.8908 0.821556 16.2956 2.12096 16.2956H9.70681C9.67271 16.0809 9.65626 15.8513 9.65626 15.6035V15.2052H1.80101C1.48105 15.2052 1.36352 15.1203 1.36352 14.8852C1.36352 13.3638 3.57711 10.7519 7.50143 10.7519C8.48527 10.7519 9.36152 10.9156 10.1224 11.1848C10.3248 10.9499 10.5998 10.7591 10.9556 10.6278ZM7.51447 8.54489C9.49298 8.54489 11.0862 6.80147 11.0862 4.64009C11.0862 2.51797 9.49298 0.833313 7.51447 0.833313C5.54252 0.833313 3.93624 2.54409 3.93624 4.6532C3.93624 6.80796 5.53596 8.54489 7.51447 8.54489ZM7.51447 7.4544C6.18896 7.4544 5.09198 6.22684 5.09198 4.6532C5.09198 3.12523 6.1824 1.92377 7.51447 1.92377C8.84654 1.92377 9.93047 3.10565 9.93047 4.64009C9.93047 6.21381 8.84005 7.4544 7.51447 7.4544ZM15.5606 11.0258C15.1894 10.8904 14.8482 10.766 14.6384 10.6866C14.3837 10.6018 14.0833 10.5952 13.7961 10.7128C13.6258 10.7763 13.3468 10.8769 13.0318 10.9905C12.4405 11.2037 11.7226 11.4625 11.3605 11.6073C10.8708 11.8032 10.6945 12.0971 10.6945 12.5868V15.6231C10.6945 17.1706 11.5825 17.7387 13.8679 19.0708C14.0573 19.1818 14.3706 19.2144 14.6123 19.0708C16.9042 17.7322 17.7922 17.1706 17.7922 15.6231V12.5868C17.7922 12.0971 17.616 11.8032 17.1262 11.6073C16.7847 11.4723 16.1366 11.2359 15.5606 11.0258ZM13.7112 15.8973L15.768 13.0569C15.8594 12.9263 15.9966 12.8414 16.1728 12.8414C16.4341 12.8414 16.6561 13.0504 16.6561 13.3181C16.6561 13.4095 16.6169 13.514 16.5516 13.6119L14.1356 16.9617C14.0507 17.0727 13.9071 17.1445 13.7308 17.1445C13.6002 17.1445 13.45 17.0857 13.3455 16.9747L11.9416 15.4337C11.8502 15.3357 11.811 15.1921 11.811 15.0811C11.811 14.8069 12.02 14.5979 12.2877 14.5979C12.4575 14.5979 12.5816 14.6828 12.6664 14.7677L13.7112 15.8973Z'
                      fill='currentColor'
                    />
                  </svg>
                )}
              />
              <span>Admin</span>
            </span>
          }
        >
          {canAccess(['ADMIN', 'SUPER_ADMIN'], userRoles) ? (
            <Menu.Item key='organization'>
              <Link
                to={{
                  pathname: '/organization',
                  search: queryString.stringify({ lang: lang }),
                }}
              >
                Organization
              </Link>
            </Menu.Item>
          ) : null}
          <Menu.Item key='13'>
            <Link
              to={{
                pathname: '/console-users',
                search: queryString.stringify({ lang: lang }),
              }}
            >
              Account
            </Link>
          </Menu.Item>
          {checkPermission('AccountPermission', permission) && (
            <Menu.Item key='13'>
              <Link
                to={{
                  pathname: '/console-users',
                  search: queryString.stringify({ lang: lang }),
                }}
              >
                Users
              </Link>
            </Menu.Item>
          )}
          {canAccess(['SUPER_ADMIN', 'ADMIN'], userRoles) ? (
            <Menu.Item key='group-permision'>
              <Link to={{ pathname: '/permission-group', search: queryString.stringify({ lang: lang }) }}>
                Permission
              </Link>
            </Menu.Item>
          ) : null}
          {canAccess(['SUPER_ADMIN', 'ADMIN'], userRoles) ? (
            <Menu.Item key='activity'>
              <Link to={{ pathname: '/console-activity', search: queryString.stringify({ lang: lang }) }}>
                Activities
              </Link>
            </Menu.Item>
          ) : null}
        </Menu.SubMenu>
      ) : null}

      {canAccess(['SUPER_ADMIN'], userRoles) ? (
        <Menu.SubMenu
          key='console-super'
          title={
            <span>
              <Icon component={IconShieldSuperAdmin} />
              <span>Super Admin</span>
            </span>
          }
        >
          {canAccess(['SUPER_ADMIN'], userRoles) ? (
            <Menu.Item key='12'>
              <Link
                to={{
                  pathname: '/console-organizations',
                  search: queryString.stringify({ lang: lang }),
                }}
              >
                Organization
              </Link>
            </Menu.Item>
          ) : null}
          {canAccess(['SUPER_ADMIN'], userRoles) ? (
            <Menu.Item key='super-admin-console-users'>
              <Link
                to={{
                  pathname: '/super-admin-console-users',
                  search: queryString.stringify({ lang: lang }),
                }}
              >
                Accounts
              </Link>
            </Menu.Item>
          ) : null}
          {canAccess(['SUPER_ADMIN'], userRoles) ? (
            <Menu.Item key='permission'>
              <Link to={{ pathname: '/console-permission', search: queryString.stringify({ lang: lang }) }}>
                Permission
              </Link>
            </Menu.Item>
          ) : null}

          {/* {canAccess(['SUPER_ADMIN'], userRoles) && hasOwnerPermission ? (
              <Menu.Item key="internal_permission">
                <Link to={{ pathname: '/internal-permission', search: queryString.stringify({ lang: lang }) }}>
                  Internal Permission
                </Link>
              </Menu.Item>
            ) : null} */}

          {canAccess(['SUPER_ADMIN'], userRoles) ? (
            <Menu.Item key='menu_link_org'>
              <Link
                to={{
                  pathname: '/console-link-orgs',
                  search: queryString.stringify({ lang: lang }),
                }}
              >
                3rd Party Link
              </Link>
            </Menu.Item>
          ) : null}
          {canAccess(['SUPER_ADMIN'], userRoles) ? (
            <Menu.Item key='menu_import'>
              <Link
                to={{
                  pathname: '/console-system-setting',
                  search: queryString.stringify({ lang: lang }),
                }}
              >
                Settings
              </Link>
            </Menu.Item>
          ) : null}
        </Menu.SubMenu>
      ) : null}
    </Menu>
  );
};
